// src/pages/consulterEvenements.jsx
import React from "react";
import Layout from "../components/Layout";
import MeetingRoom from "../components/Employé/MeetingRoom"; 

function MeetingRooms() {
  return (
    <Layout>
      <div className="p-6">
        <MeetingRoom />
      </div>
    </Layout>
  );
}

export default MeetingRooms;
